// extracted by mini-css-extract-plugin
export default {"dropdown-toggle":"DiagramList_dropdown-toggle__zDHaR","list-type-selector":"DiagramList_list-type-selector__TdOIq"};